export default {"src":"/uk/_next/static/media/hybrid-app-intro-screen-three.83cfcd4b.svg","height":148,"width":300,"blurWidth":0,"blurHeight":0};